import { useInstances } from '@/hooks/use-instances';
import { useAccountStore } from '@/store/account';
import { useAppStore } from '@/store/app';

const { getVueRouterInstance } = useInstances();
const router = getVueRouterInstance();

router.beforeEach((to, from, next) => {
  const accountStore = useAccountStore();
  const appStore = useAppStore();
  const token = to.query.token as string;
  const isIframe = to.query.iframe as string;
  if (isIframe) {
    appStore.setUseByIframe(true);
    if (token) {
      accountStore.setToken(token);
    }
  }
  next();
});
